export var viewpagerList = [{
  vdoid: "15828574025203673163",
  pic: "",
  smallcover: "https://esx.esxscloud.com/small/liveme/cover-6958eec4483d6a9fdd59e7b80149d9f4_icon.jpeg",
  videocapture: "https://esx.esxscloud.com/big/liveme/cover-39f146c7a36963244b5332c08be3c724_icon.jpeg",
  heat: "160",
  title: "Global Live #Chat #Feature",
  uname: "ぴƮɃǦ🦍"
}, {
  vdoid: "15828520768447006807",
  pic: "",
  smallcover: "https://esx.esxscloud.com/small/liveme/poster/a6d1d95fdce3fa66f8b569faf541f7bc_icon.jpeg",
  videocapture: "https://esx.esxscloud.com/big/liveme/poster/a6d1d95fdce3fa66f8b569faf541f7bc_icon.jpeg",
  heat: "160",
  title: "LIVEHOUSE starts 1030pmEST 🎸 🎶",
  uname: "JΞDI MAMA🖤㊂"
}, {
  vdoid: "15828553366874477921",
  pic: "",
  smallcover: "https://esx.esxscloud.com/small/liveme/cover-ff461f68d1b217524e95fb86ce957ea1_icon.jpeg",
  videocapture: "https://esx.esxscloud.com/big/liveme/cover-ff461f68d1b217524e95fb86ce957ea1_icon.jpeg",
  heat: "160",
  title: "#LIVEME2020Birthday Global Live 🎉🎉",
  uname: "㋡ FigzBeeTV🎨💫"
}];
export var musicHouse = [];
export var fashionHouse = [{
  vdoid: "15768063821111129699",
  pic: "",
  smallcover: "https://esx.esxscloud.com/small/liveme/cover-b14132a1fe6b5b43909df9f3410f2549_icon.jpeg",
  videocapture: "https://esx.esxscloud.com/big/liveme/cover-235fa462e8d9b62622bf61f60fb46882_icon.jpeg",
  heat: "160",
  title: "LiveMe Fashion House #livemefashionhouse",
  uname: "Danielle🍸"
}];